import React, { createContext, useEffect, useReducer } from 'react';

// third-party
import { Chance } from 'chance';
import jwtDecode from 'jwt-decode';

// reducer - state management
import { LOGIN, LOGOUT } from 'store/actions';
import accountReducer from 'store/accountReducer';

// project imports
import Loader from 'ui-component/Loader';
import API from 'utils/axios';
import auth_service from 'utils/authService';

// types
import { KeyedObject } from 'types';
import { InitialLoginContextProps, JWTContextType } from 'types/auth';

import { ROUTE_API } from 'configs';

import { openSnackbar } from "store/slices/snackbar";
import { useDispatch } from "react-redux";
const chance = new Chance();

// constant
const initialState: InitialLoginContextProps = {
    isLoggedIn: false,
    isInitialized: false,
    user: null
};

const verifyToken: (st: string) => boolean = (serviceToken) => {
    if (!serviceToken) {
        return false;
    }
    const decoded: KeyedObject = jwtDecode(serviceToken);
    /**
     * Property 'exp' does not exist on type '<T = unknown>(token: string, options?: JwtDecodeOptions | undefined) => T'.
     */
    return decoded.exp > Date.now() / 1000;
};

// ==============================|| JWT CONTEXT & PROVIDER ||============================== //
const JWTContext = createContext<JWTContextType | null>(null);

export const JWTProvider = ({ children }: { children: React.ReactElement }) => {
    const [state, dispatch] = useReducer(accountReducer, initialState);
    const dispatch2 = useDispatch();
    useEffect(() => {
        const init = async () => {
            try {
                const serviceToken = window.localStorage.getItem('accessToken');
                if (serviceToken && verifyToken(serviceToken)) {
                    const response = await API.post(`${ROUTE_API.me}`);
                    const { Data, ErrorCode } = response.data;
                    if (ErrorCode === 0) {
                        dispatch({
                            type: LOGIN,
                            payload: {
                                isLoggedIn: true,
                                user: Data.user
                            }
                        });
                        return;
                    }
                    dispatch({
                        type: LOGOUT
                    });
                } else {
                    dispatch({
                        type: LOGOUT
                    });
                }
            } catch (err: any) {
                console.error(err);
                dispatch({
                    type: LOGOUT
                });
            }
        };

        init();
    }, []);

    // each after 5 minutes fetch get access token 1 time
    // useEffect(() => {
    //     const scheduleFetchAccessToken = (): NodeJS.Timeout => {
    //         return setInterval(fetchAccessToken, 5 * 60 * 1000); // 5 minutes in milliseconds
    //     };
    //     const intervalId = scheduleFetchAccessToken();

    //     return (): void => {
    //         clearInterval(intervalId);
    //     };
    // }, []);

    // const fetchAccessToken = async (): Promise<void> => {
    //     try {
    //         const res: any = await API.post(ROUTE_API.refresh);
    //         const { Data, ErrorCode } = res.data;
    //         if (ErrorCode === 0) {
    //             auth_service.setAccessToken(Data.access_token);
    //         }
    //     } catch (err) {
    //         console.log(err);
    //     }
    // };

    const login = async (email: string, password: string) => {
        const user = { email, password };
        try {
            const res: any = await API.post(ROUTE_API.login, user, { headers: { isShowLoading: true } });
            const { Data, ErrorCode, ErrorDescription } = res.data;
            if (ErrorCode === 0) {
                auth_service.setAccessToken(Data.access_token);
                dispatch({
                    type: LOGIN,
                    payload: {
                        isLoggedIn: true,
                        user: Data.user
                    }
                });
            } else {
                showAlert(ErrorDescription, 'error');
            }
        } catch (err) {
            console.log(err);
        }
    };

    const register = async (email: string, password: string, firstName: string, lastName: string) => {
        // todo: this flow need to be recode as it not verified
        const id = chance.bb_pin();
        const response = await API.post('/api/account/register', {
            id,
            email,
            password,
            firstName,
            lastName
        });
        let users = response.data;

        if (window.localStorage.getItem('users') !== undefined && window.localStorage.getItem('users') !== null) {
            const localUsers = window.localStorage.getItem('users');
            users = [
                ...JSON.parse(localUsers!),
                {
                    id,
                    email,
                    password,
                    name: `${firstName} ${lastName}`
                }
            ];
        }

        window.localStorage.setItem('users', JSON.stringify(users));
    };

    const logout = async () => {
        try {
            auth_service.clearAccessToken();

            // const response = await API.post(ROUTE_API.logout, { headers: { cursorLoading: true } });
            // const { ErrorCode } = response.data;
            // if (ErrorCode === 0) {
            dispatch({ type: LOGOUT });
            // }
            // return response.data as any;
        } catch (err) {
            console.log(err);
        }
    };

    const resetPassword = (email: string) => console.log(email);

    const updateProfile = async () => {
        try {
            const serviceToken = window.localStorage.getItem('accessToken');
            if (serviceToken && verifyToken(serviceToken)) {
                const response = await API.post(`${ROUTE_API.me}`);
                const { Data, ErrorCode } = response.data;
                if (ErrorCode === 0) {
                    dispatch({
                        type: LOGIN,
                        payload: {
                            isLoggedIn: true,
                            user: Data.user
                        }
                    });
                }
            } else {
                dispatch({
                    type: LOGOUT
                });
            }
        } catch (err: any) {
            console.error(err);
            dispatch({
                type: LOGOUT
            });
        }
    };

    if (state.isInitialized !== undefined && !state.isInitialized) {
        return <Loader />;
    }

    const showAlert = (str: string = '', type: string = 'success') => {
        dispatch2(
            openSnackbar({
                open: true,
                message: str,
                anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
                variant: 'alert',
                alert: {
                    color: type,
                },
                transition: 'Fade',
                close: false
            })
        );
    }
    return (
        <JWTContext.Provider value={{ ...state, login, logout, register, resetPassword, updateProfile, showAlert }}>{children}</JWTContext.Provider>
    );
};

export default JWTContext;
